import { AlertTriangle, LogOut } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useSignOutMutation } from '@/hooks/useSignOut';

export function NoAssociatedStudentFallback() {
  const { mutateAsync: onSignOut } = useSignOutMutation();

  const handleLogout = () => {
    onSignOut();
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-sky-100 to-indigo-200/80 p-5">
      <div className="mb-8">
        <img src="/logo.png" alt="TimeBack Logo" className="h-16 w-auto" />
      </div>

      <div className="w-full max-w-lg px-4 sm:px-0">
        <Card className="border-muted/40 shadow-lg">
          <CardHeader className="space-y-1 pb-4 text-center">
            <div className="flex justify-center mb-3">
              <AlertTriangle className="h-12 w-12 text-amber-600" />
            </div>
            <CardTitle className="text-xl">Account Setup Required</CardTitle>
          </CardHeader>

          <CardContent>
            <Alert className="border-amber-200 bg-amber-50">
              <AlertDescription className="text-amber-800">
                <div className="space-y-3">
                  <p>
                    Your account is not currently associated with any student
                    accounts. In order to access their metrics, your account
                    must be associated with students' profiles.
                  </p>
                  <p>
                    <strong>Please reach out to TimeBack Support</strong> to
                    have your account linked to students' profiles and gain
                    access to their metrics.
                  </p>
                </div>
              </AlertDescription>
            </Alert>
          </CardContent>
        </Card>

        <div className="flex justify-center mt-6">
          <Button
            variant="outline"
            onClick={handleLogout}
            className="flex items-center gap-2 bg-white/90 hover:bg-white"
          >
            <LogOut className="h-4 w-4" />
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
}
